import { useTranslate } from '@refinedev/core';
import * as React from 'react';

import type * as types from '../types';

export const useInternalTranslate = () => {
	const translate = useTranslate();

	return React.useCallback<types.InternalTranslateFunction>(
		(
			key: string,
			{
				fallback,
				ns = 'common',
				data = {},
			}: {
				fallback: string;
				ns?: string;
				data?: object;
			}
		) => translate(key, { ns, ...data }, fallback),
		[translate]
	);
};
